import type { Filter } from "@estelle/domain";

/**
 * A section of Orders that is All Orders under a standing condition.
 *
 * Declared once, here, because two things have to apply it and used to each
 * write it out: the list, which sends it to the repository, and the export,
 * which did not — Unfulfilled showed 13 rows and Export downloaded all 40.
 */
export interface StandingCondition {
  field: string;
  operator: "is" | "is_not" | "is_empty";
  value?: string;
}

/** Unfulfilled: orders nothing has shipped for. */
export const UNFULFILLED: StandingCondition = {
  field: "fulfilmentStatus",
  operator: "is_empty",
};

/**
 * The user's filter with the section's standing condition ANDed in front.
 *
 * Applied on top of whatever the user has built rather than replacing it, so
 * Unfulfilled stays unfulfilled while someone filters within it. A section
 * that overwrote the user's filter would silently discard work the moment they
 * changed section.
 */
export function withStanding(
  standing: StandingCondition | undefined,
  filter: Filter,
): Filter {
  if (!standing) return filter;
  return {
    kind: "group",
    combinator: "and",
    children: [
      {
        kind: "condition",
        field: standing.field,
        operator: standing.operator,
        ...(standing.value === undefined ? {} : { value: standing.value }),
      },
      filter,
    ],
  };
}
